import { Schema, model, models } from "mongoose";
import { IBlock } from "./types";

const blockSchema = new Schema<IBlock>(
  {
    chainId: { type: Number, required: true },
    contract: { type: String, required: true },
    block: { type: Number, required: true },
    signature: { type: String, required: true },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
    },
  }
);

blockSchema.index({ chainId: 1 });

export const BlockModel = models?.Block || model<IBlock>("Block", blockSchema);
